import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/axiosSuperAdmin';
import { toast } from '../../components/Toast';
import './SuperAdmin.css';

function PlanManagement() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [overrides, setOverrides] = useState('');

  const fetchCompanies = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get('/superadmin/companies?size=100');
      const data = res.data.data || res.data;
      setCompanies(data.content || data);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to load companies');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchCompanies(); }, [fetchCompanies]);

  const showSuccess = (msg) => { toast.success(msg); };

  const handleSelect = (company) => {
    setSelected(company);
    setOverrides(company.featureOverrides ? company.featureOverrides.join(', ') : '');
  };

  const handleSaveOverrides = async () => {
    if (!selected) return;
    const featureKeys = overrides.split(',').map(s => s.trim()).filter(Boolean);
    try {
      await axios.put(`/superadmin/companies/${selected.id}/feature-overrides`, { featureKeys });
      showSuccess('Feature overrides saved');
      fetchCompanies();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save overrides');
    }
  };

  return (
    <div className="sa-page">
      <h1 className="sa-title">Plan & Feature Management</h1>

      <div className="sa-split">
        <div className="sa-list-panel">
          <h2>Companies</h2>
          {loading ? <div className="sa-loading">Loading...</div> : (
            <ul className="sa-company-list">
              {companies.map(c => (
                <li
                  key={c.id}
                  className={`sa-company-item ${selected?.id === c.id ? 'active' : ''}`}
                  onClick={() => handleSelect(c)}
                >
                  <span>{c.name}</span>
                  <span className={`sa-badge sa-badge-${c.planTier?.toLowerCase()}`}>{c.planTier || 'FREE'}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="sa-detail-panel">
          {selected ? (
            <>
              <h2>{selected.name} — Feature Overrides</h2>
              <p className="sa-hint">
                Enter comma-separated feature keys to grant beyond the plan defaults.
                Leave empty to use plan defaults only.
              </p>
              <div className="form-group">
                <label>Feature Keys</label>
                <textarea
                  rows={4}
                  value={overrides}
                  onChange={e => setOverrides(e.target.value)}
                  placeholder="e.g. payroll, advanced_reports, crm"
                />
              </div>
              <button className="sa-btn sa-btn-primary" onClick={handleSaveOverrides}>
                Save Overrides
              </button>
            </>
          ) : (
            <div className="sa-empty-detail">Select a company to manage feature overrides</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PlanManagement;
